import { QuestionPlanStockTerm as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-term";

import { useDayTripPlanStockTerm } from "./hooks";

export const QuestionDayTripPlanStockTerm = () => {
	const {
		maxStockNum,
		stockTypeTarget,
		stockTypeTerm,
		onSetMaxStockNum,
		onSetStockTypeTarget,
		onSetStockTypeTerm,
		isEdited,
		hasError,
	} = useDayTripPlanStockTerm();

	return (
		<Question
			maxStockNum={maxStockNum}
			stockTypeTarget={stockTypeTarget}
			stockTypeTerm={stockTypeTerm}
			onSetMaxStockNum={onSetMaxStockNum}
			onSetStockTypeTarget={onSetStockTypeTarget}
			onSetStockTypeTerm={onSetStockTypeTerm}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
};
